import request from '@/utils/request';
import { BASE_URL } from '@/utils/global';

// 查询图片标签列表
export const getImageLabelList = (data: any, params: any = {}) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/tag/queryList.ac`,
    method: 'post',
    data,
    params,
  });
};

// 新增图片标签
export const saveImageLabel = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/tag/save.ac`,
    method: 'post',
    data,
  });
};

// 编辑图片标签
export const editImageLabel = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/tag/edit.ac`,
    method: 'post',
    data,
  });
};

// 删除图片标签
export const deleteImageLabel = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/tag/delete.ac`,
    method: 'post',
    data,
  });
};

// 启、停用图片标签
export const enableImageLabel = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/tag/enable.ac`,
    method: 'post',
    data,
  });
};

// 批量启、停用图片标签
export const batchEnableImageLabel = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/tag/batchUpdateStatus.ac`,
    method: 'post',
    data,
  });
};

export const queryImageLabelByRelationId = (data: any) => {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/tag/queryByRelationId.ac`,
    method: 'post',
    data,
  });
};
